// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__KtSWS","content":"modal_content__O8ZBY","btn_close":"modal_btn_close__aUkHk"};